import menu from './menu.js'
import cmylogo from './cmylogo.js'
import consoleMessage from './console.js'
import autosizes from './autosizes.js'
import overlay from './overlay.js'
import BikeSelector from './bikeselector.js'
import Select from './select.js'
import help from './help.js'
import Reprint from './reprint.js'
import Insurance from './insurance.js'
import OrderTracker from './ordertracker.js'

window.log = console.log

document.addEventListener('DOMContentLoaded', () => {

	menu()
	autosizes()
	cmylogo()
	consoleMessage()
	overlay()
	BikeSelector.setup()
	Select.setup()
	help()
	Reprint.setup()
	Insurance.setup()
	// OrderTracker.setup()
	
})


